import React from 'react';
import { Box, LinearProgress, Paper, Typography } from '@mui/material';
import { TimesheetRun } from '../types';
import { percent } from '../utils';

interface Props {
  run: TimesheetRun;
}

/** Тонкая полоса хода массового создания над таблицей: видна и при закрытом диалоге настроек */
const RunBanner: React.FC<Props> = ({ run }) => {
  const done = percent(run.processed, run.total);
  return (
    <Paper variant="outlined" sx={{ px: 2, py: 1.25, borderRadius: 2, borderColor: '#bfdbfe', bgcolor: '#eff6ff' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, mb: 0.75 }}>
        <Typography variant="body2" sx={{ fontWeight: 600, color: '#1e3a8a' }}>
          Создание табелей: обработано {run.processed.toLocaleString('ru-RU')} из {run.total.toLocaleString('ru-RU')}
        </Typography>
        <Typography variant="caption" sx={{ color: '#475569' }}>
          создано {run.created}, уже были {run.existing}{run.failed > 0 ? `, ошибок ${run.failed}` : ''}
        </Typography>
      </Box>
      <LinearProgress variant="determinate" value={done} sx={{ height: 6, borderRadius: 3, bgcolor: '#dbeafe' }} />
    </Paper>
  );
};

export default React.memo(RunBanner);
